import { Component, Input, OnInit } from '@angular/core';

import { RolesService } from 'src/app/core/api/services';
import { AppRoleSelectionListInputType } from 'src/app/core/types/app-role-selection-list-input-type.type';
import { BaseSelectSearch } from './base/base-select-search.component';
import { BaseSelectSearchModule } from './base/base-select.search.module';

@Component({
    selector: 'role-select-search',
    templateUrl: './base/base-select-search-template.html',
    imports: [BaseSelectSearchModule]
})
export class RoleSelectSearchComponent
  extends BaseSelectSearch
  implements OnInit
{
  @Input('type') input_type: AppRoleSelectionListInputType = 'roles';

  constructor(protected currentService: RolesService) {
    super();
  }

  initConfig() {
    if (!this.label) this.label = 'common.roles';
    this.optionValue = 'key';
    this.optionTitle = 'value';
  }

  getItemsApi() {
    switch (this.input_type) {
      case 'roles':
        this.currentService
          .rolesGetRoles()
          .pipe(this.basePipeOperators())
          .subscribe(this.baseObserver);
        break;
      case 'organizationRoles':
        this.currentService
          .rolesGetRoles2({ organizationId: +this.id })
          .pipe(this.basePipeOperators())
          .subscribe(this.baseObserver);
    }
  }
}
